module.exports = __webpack_public_path__ + "img/dbd.62abca50.png";